// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-material/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springMaterialEN: PageEntry = {
  id: "post.federmaterial",
  locale: "en",
  slug: "spring-material",
  seo: {
    title: "Glossary: Spring material explained simply | Dietz GmbH",
    description: "The spring material refers to the material from which a spring is made. Springs can be made of different materials such as steel, stainless steel, titanium, plastic or alloys. The ",
  },
  type: "post",
  h1: "Glossary: Spring material explained simply",
  intro: "The spring material refers to the material from which a spring is made. Springs can be made of different materials such as steel, stainless steel, titanium, plastic or alloys. The choice of the appropriate spring material depends on the specific requirements of the application, including the required strength, elasticity, corrosion resistance and thermal stability. Choosing the right spring material is crucial to ensure that the spring can withstand the stresses in its environment and maintain its function over a long period of time.",
  blocks: [

  ],
};
